import "./separator.css";

function Separator(props) {
  return <div id={props.id} className="separator"></div>;
}

export default Separator;
